import React from "react";
import { init } from "@sentry/browser";
import PropTypes from 'prop-types';

// Connect the app with Sentry
export default function SentryInitialize({
	dsn,
	release,
	environment,
}) {
	React.useEffect(() => {
		init({
			dsn: dsn,
			release: release,
			environment: environment,
		});
	// eslint-disable-next-line
	}, []);

	return null;
}

SentryInitialize.propTypes = {
	dsn: PropTypes.string.isRequired,
	release: PropTypes.number.isRequired,
	environment: PropTypes.string.isRequired,
};
